// Actions
import reduce from 'lodash/reduce';
const SET_DATA = 'zen/dataSources/SET_DATA';
const SAVE_ACCOUNT = 'zen/dataSources/SAVE_ACCOUNT';

const initialState = {
  accountId: 0,
  dataSources: {
    twitter: true,
    vk: false,
    weibo: false,
    social_platform: false
  },
  enrichments: {
    geoReferencing: false,
    threatLevel: false
  },
  sourceOptions: []
};

// Reducer
const reducer = (state = { ...initialState }, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case SET_DATA:
      return reduce(payload, (obj, value, key) => {
        obj[key] = {...obj[key], ...value};
        return obj;
      }, {...state});
    default:
      return state;
  }
};

// Action Creators
const setData = (payload) => {
  return { type: SET_DATA, payload };
};
const saveAccount = (payload) => {
  return { type: SAVE_ACCOUNT, payload };
};

export default reducer;

export {
  // Actions
  SET_DATA,
  SAVE_ACCOUNT,
  // Action Creators
  setData,
  saveAccount
};
